import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useAuthContext } from "./contexts/AuthContext";
import HomePage from "./pages/HomePage";
import SignInPage from "./pages/SignInPage";
import Header from "./layout/Header";
import Container from "./components/Container";
import SideMenu from "./layout/SideMenu";
import MainLoader from "./layout/MainLoader";
import Page from "./layout/Page";
import WalletPage from "./pages/WalletPage";
import EventsPage from "./pages/EventsPage";
import ComparatorPage from "./pages/ComparatorPage";
import RentabilityPage from "./pages/analysis/RentabilityPage";
import { HomeProvider } from "./contexts/HomeContext";
import { SecureProvider } from "./contexts/SecureContext";
import { AssetProvider } from "./contexts/AssetContext";
import { AssetSidebarProvider } from "./contexts/AssetSidebarContext";
import { TaxImportProvider } from "./contexts/TaxImportContext";
import { register } from '../serviceWorker';
import { NotificationProvider } from "./contexts/NotificationContext";
import { ScrollPanel } from "primereact/scrollpanel";
import { ConfirmDialog } from "primereact/confirmdialog";
import EvolutionPage from "./pages/analysis/EvolutionPage";
import BadGatewayPage from "./pages/BadGatewayPage";
import EarningsPage from "./pages/analysis/EarningsPage";
import ProjectionPage from "./pages/analysis/ProjectionPage";
import RealEstateFunds from "./pages/analysis/RealEstateFunds";
import ProfilePageV2 from "./pages/ProfilePageV2";
import SsoLogoffPage from "./pages/SsoLogoffPage";

register();

function App() {
  const authContext = useAuthContext();

  return (
    <>
      {
        authContext.isLoading
          ? (
            <MainLoader />
          )
          : (
            <SecureProvider>
              {
                !authContext.isAuthenticated
                  ? (
                    <BrowserRouter>
                      <Routes>
                        <Route path="/sso/google/logoff" element={<SsoLogoffPage />} />
                        <Route path="/sso/apple/logoff" element={<SsoLogoffPage />} />
                        <Route path="/" element={<SignInPage />} />
                      </Routes>
                    </BrowserRouter>
                  )
                  : (
                    <NotificationProvider>
                      <ConfirmDialog />

                      <BrowserRouter>
                        <HomeProvider>
                          {
                            (isLoading) => {
                              if (isLoading) {
                                return <MainLoader />
                              }

                              return (
                                <>
                                  <TaxImportProvider>
                                  <AssetSidebarProvider>
                                    <Header />

                                    <Container className="h-full bg-gray-100">
                                      <AssetProvider>
                                        <Container paddingHorizontal="4" className="side-menu" maxWidth={250} fullWidth>
                                          <SideMenu />
                                        </Container>

                                      <ScrollPanel style={{ width: '100%', height: 'calc(100vh - 99px)' }} className="custombar1 content">
                                        <Container
                                          paddingHorizontal="2"
                                          paddingVertical="2"
                                          fullWidth
                                          className="min-h-screen bg-gray-100"
                                        >
                                          <Routes>
                                            <Route path="/sso/google/logoff" element={<SsoLogoffPage />} />
                                            <Route path="/sso/apple/logoff" element={<SsoLogoffPage />} />

                                            <Route
                                              path="/"
                                              element={
                                                <Page>
                                                  <HomePage />
                                                </Page>
                                              }
                                            />

                                            <Route
                                              path="/wallet"
                                              element={
                                                <Page title="Minha Carteira" subTitle="Aqui você encontra o total do seu patrimônio ativo.">
                                                  <WalletPage />
                                                </Page>
                                              }
                                            />

                                            <Route
                                              path="/events"
                                              element={
                                                <Page title="Eventos da Carteira">
                                                  <EventsPage />
                                                </Page>
                                              }
                                            />

                                            <Route
                                              path="/analysis"
                                            >
                                              <Route
                                                path="rentability"
                                                element={
                                                  <Page title="Rentabilidade Histórica" subTitle="Histórico de ativos vencidos e inativos">
                                                    <RentabilityPage />
                                                  </Page>
                                                }
                                              />

                                              <Route
                                                path="evolution"
                                                element={
                                                  <Page title="Evolução patrimonial">
                                                    <EvolutionPage />
                                                  </Page>
                                                }
                                              />

                                              <Route
                                                path="earnings"
                                                element={
                                                  <Page title="Proventos">
                                                    <EarningsPage />
                                                  </Page>
                                                }
                                              />

                                              <Route
                                                path="projection"
                                                element={
                                                  <Page title="Projeção">
                                                    <ProjectionPage />
                                                  </Page>
                                                }
                                              />

                                              <Route
                                                path="fiis"
                                                element={
                                                  <Page title="Fundos Imobiliários">
                                                    <RealEstateFunds />
                                                  </Page>
                                                }
                                              />
                                            </Route>

                                            <Route
                                              path="/comparator"
                                              element={
                                                <Page title="Comparador de Investimentos">
                                                  <ComparatorPage />
                                                </Page>
                                              }
                                            />

                                            <Route
                                              path="/profile"
                                              element={
                                                <Page>
                                                  <ProfilePageV2 />
                                                </Page>
                                              }
                                            />

                                            <Route
                                              path="/bad-gateway"
                                              element={
                                                <BadGatewayPage />
                                              }
                                            />
                                          </Routes>
                                        </Container>
                                      </ScrollPanel>
                                    </AssetProvider>
                                  </Container>
                                </AssetSidebarProvider>
                                  </TaxImportProvider>
                              </>
                            )
                            }
                          }
                        </HomeProvider>
                      </BrowserRouter>
                    </NotificationProvider>
                  )
              }
            </SecureProvider>
          )
      }
    </>
  )
}

export default App;
